__turbopack_context__.v({
  "tabPanel": "qPBbyq_tabPanel",
  "tabs": "qPBbyq_tabs",
});
